/**
 * Select.jsx
 *
 * @Author: wang yinan
 * @Date: 2018/3/08 下午5:12
 */

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '../input';
import Tag from '../tag';

/**
 * @ignore
 * */
class TagsInput extends Component {
  static propTypes = {
    placeholder: PropTypes.node,
    tags: PropTypes.array,
    searchText: PropTypes.node,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    inputProps: PropTypes.object,
    tagRender: PropTypes.func,
    size: PropTypes.oneOf(['large', 'medium', 'small', 'base']), // base === medium
  };

  static defaultProps = {
    multiple: true,
    prefixCls: 'ne-tag-select-input',
    readOnly: false,
    disabled: false,
    size: 'medium',
    tags: [],
    searchText: '',
  };

  componentDidUpdate() {
    const { searchText } = this.props;
    if (searchText && this.inputRef && this.mirrorRef) {
      this.inputRef.style.width = `${this.mirrorRef.clientWidth + 8}px`;
    } else if (this.inputRef) {
      this.inputRef.style.width = '';
    }
  }

  handleTagClick = e => {
    e.stopPropagation();
  };

  getInputRef = el => {
    this.inputRef = el;
  };

  handleFocus = e => {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus(e);
    }
  };

  handleBlur = e => {
    const { onBlur } = this.props;
    if (onBlur) {
      onBlur(e);
    }
  };

  handleClick = e => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
    if (this.inputRef) {
      this.inputRef.focus();
    }
  };

  maskRender = (props, handlers, focused) => {
    const {
      disabled,
      tags,
      tagRender,
      size,
      onTagDelete,
      prefixCls,
      searchText,
      placeholder,
      id,
      readOnly,
      onKeyDown,
    } = this.props;
    return (
      <div className={`${prefixCls}-container`}>
        {!tags.length && !searchText && !focused ? (
          <span className={`${prefixCls}-placeholder`}>{placeholder}</span>
        ) : (
          <Fragment>
            {tags.map((tag, index) =>
              tagRender ? (
                tagRender(tag, size, this.handleTagClick)
              ) : (
                <Tag
                  key={tag.value + index}
                  closable
                  onDelete={() => {
                    onTagDelete(tag.value);
                  }}
                  disabled={disabled}
                  size={size}
                  onClick={this.handleTagClick}>
                  {tag.label}
                </Tag>
              ),
            )}
            <span className={`${prefixCls}-mirror`} ref={this.getMirror}>
              {searchText}
            </span>
          </Fragment>
        )}
        <input
          id={id}
          readOnly={readOnly}
          className={`${prefixCls}-base ${prefixCls}-base-${size}`}
          ref={this.getInputRef}
          value={searchText || ''}
          onKeyDown={onKeyDown}
          {...handlers}/>
      </div>
    );
  };

  getMirror = el => {
    this.mirrorRef = el;
  };

  render() {
    const {
      prefixCls,
      className,
      children,
      placeholder,
      tags,
      onTagDelete,
      size,
      defaultSearchText,
      searchText,
      searchable,
      tagRender,
      disabled,
      onClick,
      onFocus,
      id,
      readOnly,
      onKeyDown,
      maskRef,
      ...other
    } = this.props;
    return (
      <Input
        className={classNames(
          className,
          {
            [`${prefixCls}-searchable`]: searchable,
          },
          `${prefixCls}-${size}`,
          prefixCls,
        )}
        autoComplete="off"
        onClick={this.handleClick}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        aria-haspopup="true"
        disabled={disabled}
        value={searchText}
        maskRender={this.maskRender}
        size={size}
        {...other}/>
    );
  }
}

export default TagsInput;



// WEBPACK FOOTER //
// ./src/tagSelect/TagInput.jsx